import { useQuery } from "@tanstack/react-query";
import { client } from "@/lib/hono";

export const useGetPublicAvatars = () => {
    return useQuery({
        queryKey: ["avatars", "public"],
        queryFn: async () => {
            const response = await client.api.avatars.heygen.avatars.public.library.$get();
            if (!response.ok)
                throw new Error("Failed to load public avatars");
            const json = await response.json();
            return json.data.avatars;
        },
        staleTime: 1000 * 60 * 60, // 1h client-side; server caches 24h in KV
    });
};
